import { AuthorPageContentProps } from "@/types/modules/post/components";
import Image from "next/image";
import React from "react";

export const SocialButtons: React.FC<AuthorPageContentProps> = ({ author }) => {
  return (
    <>
      <a
        href={author?.socials?.facebook!}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="mr-3 flex items-center justify-center rounded-full border border-dark-10 bg-white px-5 py-2 text-center transition-all ease-in-out hover:bg-dark-10 dark:hover:bg-middle-light-turquoise"
      >
        <Image
          src="/assets/images/icons/facebook-black.svg"
          alt="Facebook Icon"
          width={20}
          height={20}
          className="h-[20px] w-[20px] object-cover"
        />
      </a>
      <a
        href={author?.socials?.twitter!}
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="mr-3 flex items-center justify-center rounded-full border border-dark-10 bg-white px-5 py-2 text-center transition-all ease-in-out hover:bg-dark-10 dark:hover:bg-middle-light-turquoise"
      >
        <Image
          src="/assets/images/icons/twitter-black.svg"
          alt="Twitter Icon"
          width={20}
          height={20}
          className="h-[20px] w-[20px] object-cover"
        />
      </a>
    </>
  );
};
